import { RuleSetServiceV2 } from './RuleSetServiceV2';

export default RuleSetServiceV2;
